// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__G_bOI","section__content":"style_section__content__Vc7Pt","contact-us-icon":"style_contact-us-icon__Wr3X8","terms":"style_terms__bIAkt"};